module.exports = __webpack_public_path__ + "static/media/bravery_media_ilus.57ef9b1c.jpg";